<template lang="pug">
.send-message-read-families-modal
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc hide-footer)
    .send-message-read-families-modal-table
      .thead
        .header-line
          .th.room-name 部屋名
          .th.redident-name 利用者名
          .th.family-name 家族ユーザー名
          .th.position 役割
          .th.tel 電話番号
      .tbody
        .body-line(v-for="family in families")
          .td.room-name {{ family.residentRoomName }}
          .td.redident-name {{ family.residentName }}
          .td.family-name {{ family.familyName }}
          .td.position(v-if="family.familyPosition") {{ family.familyPosition }}
          .td.position(v-else) 未設定
          .td.tel {{ family.familyTel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import SendMessageReadFamilyModel from "@/commons/services/SendMessageReadFamilies";

/**
 * ### 安否確認(家族) 確認者家族詳細モーダル
 */
@Component
export default class SafetyConfirmFamiliesModal extends Vue {
  /** 表示可否 */
  @Prop()
  value!: boolean;

  /** 表示対象の家族 */
  @Prop()
  families!: Array<SendMessageReadFamilyModel>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>
